import apiSvc from '../../../core/services/apiSvc';

export interface ReverseVisitMultiParams {
    ceid: string; // single CEID
    type: string; // e.g. 'FILE', 'ENCNUM', etc.
    value?: string; // value for the type (e.g. file id, encounter id)
    notes?: string;
    unlockForReload?: boolean;
    resetFileHash?: boolean;
    resetRecordHash?: boolean;
    useDate?: boolean;
    startDate?: string;
    endDate?: string;
}

const visitsRepo = {
    async reverseVisitMulti(params: ReverseVisitMultiParams): Promise<void> {
        console.log('visitsRepo.reverseVisitMulti', params);
        if (!params.ceid || !params.type) {
            throw new Error('visitsRepo.reverseVisitMulti: ceid and type are required');
        }
        const endpoint = 'ops/visits/reverse';
        const payload: any = {
            Context: {
                CEID: [params.ceid],
            },
            Entity: {
                Params: {
                    Type: params.type,
                    Notes: params.notes || '',
                    Value: params.value,
                    EncDate: !!params.useDate,
                    ResetFileHash: !!params.resetFileHash,
                    ResetRecordHash: !!params.resetRecordHash,
                },
            },
        };
        if (params.useDate) {
            payload.Entity.Params.StartDate = params.startDate;
            payload.Entity.Params.EndDate = params.endDate;
        }
        await apiSvc.post(endpoint, payload);
    },
};

export default visitsRepo;
